import { TimelinePipe } from "@pnp/core";
import { LogNotifications } from "./log-notifications";
import { Picker } from "../Picker";
import { ResolveWithPicks } from "./resolves";
import { Setup } from "./setup";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";

const debug = initDebugger('popup-behaviors');

export function Close(): TimelinePipe<Picker> {
    return (instance: Picker) => {
        instance.on.close(function (this: Picker) {
            debug('Close')
            // @ts-ignore
            this.emit[this.InternalResolveEvent](null);
            this.window.close();
        });
        return instance;
    };
}

export function CloseOnPick(): TimelinePipe<Picker> {
    return (instance: Picker) => {
        instance.on.pick(async function (this: Picker, data) {
            debug('CloseOnPick')
            this.window.close();
        });
        return instance;
    };
}

export function Popup(): TimelinePipe<Picker> {
    return (instance: Picker) => {
        instance.using(
            Setup(),
            Close(),
            LogNotifications(),
            ResolveWithPicks(),
            CloseOnPick(),
        );
        return instance;
    };
}
